<script lang="ts">
  let open = false

  function toggle() {
    open = !open
    let target = document.querySelector(".js-sidebar")
    if (open) {
      target.classList.remove("below-xl:hidden", "hidden")
    } else {
      target.classList.add("below-xl:hidden", "hidden")
    }
  }
</script>

<button class="xl:hidden relative inline-end-1" class:open aria-label="Menu" on:click={toggle}>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round">
    <line class="top" x1="3" y1="6" x2="21" y2="6" />
    <line class="middle" x1="3" y1="12" x2="21" y2="12" />
    <line class="bottom" x1="3" y1="18" x2="21" y2="18" />
  </svg>
</button>

<style lang="postcss">
  button {
    position: relative;
    margin-inline: -14px;

    align-items: center;
    background-color: inherit;
    color: var(--color-gray-500);

    &:hover,
    &:active {
      color: var(--color-primary-700);
    }

    /* Avoid random items in the header being highlighted when the user clicks/taps the hamburger menu */
    user-select: none;
    -webkit-user-select: none;

    & svg {
      stroke-width: 1.5px;
      & > * {
        transition: all 0.2s ease-in-out;
      }
    }

    &.open svg {
      & .top {
        transform: rotate(45deg);
        transform-origin: 4px 8px;
      }
      & .middle {
        opacity: 0;
      }
      & .bottom {
        transform: rotate(-45deg);
        transform-origin: 5px 16px;
      }
    }
  }
</style>
